import { render, staticRenderFns } from "./DashboardBaner.vue?vue&type=template&id=023fe83e&scoped=true"
import script from "./DashboardBaner.vue?vue&type=script&lang=js"
export * from "./DashboardBaner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023fe83e",
  null
  
)

export default component.exports